/**
 * A function that always returns the Boolean value of `true`
 *
 * @kind function
 * @name alwaysTrue
 * @sig * -> Boolean
 * @returns {Boolean} A value of `true`
 */
function alwaysTrue() {
  return true;
}

export default alwaysTrue;
